import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getSalesRecordProductType } from "../../../http/api/MasterAPI";

const SalesRecordProductTypeSelect = ({ onChange, value }) => {
  const [listSalesRecordProductType, setListSalesRecordProductType] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListSalesRecordProductType() {
    try {
      const response = await getSalesRecordProductType();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          salesRecordProductTypeCd: element.varCd,
          salesRecordProductTypeName: element.varValue1,
        }))
        .filter(
          (x) => x.salesRecordProductTypeName && x.salesRecordProductTypeName.trim() !== ""
        );
      setListSalesRecordProductType(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListSalesRecordProductType();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listSalesRecordProductType.map((item) => (
          <MenuItem
            key={item.salesRecordProductTypeCd}
            value={item.salesRecordProductTypeCd}
          >
            {item.salesRecordProductTypeName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default SalesRecordProductTypeSelect;
